<template>
    <div class="content">
      <div class="emptybg">
      <div class="emptyimg"></div>
      <div class="empty">게시물이 없습니다
        </div>
    </div>
    </div>
</template>

<script>
    export default {
        name: "BoardEmptyDefaultLayout"
    }
</script>

<style scoped>

</style>